export enum ForexInitiationTypes {
  API_SUCCESS = "@@forex_init/API_SUCCESS",
  API_ERROR = "@@forex_init/API_ERROR",
  GET_INIT_DATA = "@@forex_init/GET_INIT_DATA",
  ADD_INIT_DATA = "@@forex_init/ADD_INIT_DATA",
  UPDATE_INIT_STATUS = "@@forex_init/UPDATE_INIT_STATUS",
}
